// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Search: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 16 16" enableBackground="new 0 0 16 16" xmlSpace="preserve" fill="currentColor">
<path d="M15.2,14.43l-3.61-3.61c0.89-1.09,1.43-2.49,1.43-4.01c0-3.49-2.83-6.32-6.32-6.32c-3.49,0-6.32,2.83-6.32,6.32
	s2.83,6.32,6.32,6.32c1.52,0,2.91-0.54,4-1.43l3.61,3.6c0.24,0.24,0.64,0.24,0.88,0C15.44,15.07,15.44,14.68,15.2,14.43z M6.7,11.88
	c-2.79,0-5.07-2.27-5.07-5.06S3.91,1.76,6.7,1.76c2.79,0,5.07,2.27,5.07,5.07S9.5,11.88,6.7,11.88z"/>
</svg>;
};

export default React.memo(Search);
